import { Scanner } from "@yudiel/react-qr-scanner";
import { Box, Button, Dialog, DialogActions } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "./LanguageContext";

function QrScanner({ onScan, onClose, scan = true }) {
    const navigator = useNavigate();
    const { text } = useLanguage();

    function isValidURL(str) {
        try {
            new URL(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    const onSelfScan = (result) => {
        // console.log(result);
        if (onScan) onScan(result[0].rawValue);
        if (isValidURL(result[0].rawValue)) navigator(result[0].rawValue);
        else alert(result[0].rawValue);
    }

    const onSelfError = (err) => {
        if (onClose) onClose();
    }

    const onSelfClose = () => {
        if (onClose) onClose();
        else navigator("/");
    }

    if (!scan) return;
    return (
        <Dialog open={scan} onClose={onSelfClose}>
            <Box m={2} textAlign={"center"}>
                <Scanner
                    formats={["code_128", "qr_code"]}
                    onScan={onSelfScan}
                    onError={onSelfError}
                    sound={false}
                    paused={!scan}
                />
            </Box>
            <DialogActions sx={{ pb: 2, px: 2 }}>
                <Button variant="outlined" color="secondary" onClick={onSelfClose}>{text("close")}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default QrScanner;